import { Field } from "formik";

import RowInput from "../../FormElements/RowInput";

export const ProjectUnitForm = ({ defaultValues, translate }) => (
  <>
    <Field
      type="number"
      disabled={defaultValues.isDisabled}
      label={translate("coFinancing")}
      name={"coFinancing"}
      component={RowInput}
      addonText="€"
    />

    <Field
      disabled={defaultValues.isDisabled}
      label={translate("cup")}
      name={"cup"}
      component={RowInput}
    />
  </>
);
